/* wod3d-parcheado-build:20260919155008 */
/**
 * WOD3D — Landing QR «Te han parcheado»
 * Tiny helpers: ?patch= / ?id= personalization, chain scan, reveal, tracking.
 * No dependencies. Safe if analytics APIs / chain API are absent.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-wod3d-parcheado]');
  if (!root) return;

  var VISITOR_KEY = 'wod3d_patch_vid';
  var SCAN_TIMEOUT_MS = 2000;
  var PHYSICAL_ID_RE = /^[A-Za-z]{2}-[A-Za-z0-9]{3,8}$/;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var chainMeta = {
    physical_id: null,
    chain_count: null,
    visitor_position: null,
    is_new_chain_member: null,
    patch_kind: null,
  };

  function readParams() {
    var out = {
      patch: '',
      id: '',
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
      utm_content: '',
      utm_term: '',
    };
    try {
      var sp = new URLSearchParams(window.location.search);
      Object.keys(out).forEach(function (key) {
        var v = sp.get(key);
        if (v) out[key] = String(v).trim();
      });
    } catch (_) {}
    return out;
  }

  var params = readParams();
  var currentPatch = params.patch || '';
  var physicalId = '';
  if (params.id && PHYSICAL_ID_RE.test(params.id)) {
    physicalId = params.id.toUpperCase();
  }

  function track(eventName, extra) {
    var payload = {
      page: 'parcheado',
      patch: currentPatch || null,
      utm_source: params.utm_source || null,
      utm_medium: params.utm_medium || null,
      utm_campaign: params.utm_campaign || null,
      utm_content: params.utm_content || null,
      utm_term: params.utm_term || null,
    };
    if (chainMeta.physical_id) {
      payload.physical_id = chainMeta.physical_id;
      payload.chain_count = chainMeta.chain_count;
      payload.visitor_position = chainMeta.visitor_position;
      payload.is_new_chain_member = chainMeta.is_new_chain_member;
      if (
        chainMeta.patch_kind === 'roast' ||
        chainMeta.patch_kind === 'positive' ||
        chainMeta.patch_kind === 'flirt'
      ) {
        payload.patch_kind = chainMeta.patch_kind;
      }
    }
    if (extra && typeof extra === 'object') {
      Object.keys(extra).forEach(function (k) {
        payload[k] = extra[k];
      });
    }

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(eventName, payload);
        return;
      }
    } catch (_) {}

    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: eventName }, payload));
      }
    } catch (_) {}
  }

  function uuidFallback() {
    var bytes = new Uint8Array(16);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      window.crypto.getRandomValues(bytes);
    } else {
      return '';
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    var hex = [];
    for (var i = 0; i < bytes.length; i++) {
      hex.push((bytes[i] + 0x100).toString(16).slice(1));
    }
    return (
      hex.slice(0, 4).join('') +
      '-' +
      hex.slice(4, 6).join('') +
      '-' +
      hex.slice(6, 8).join('') +
      '-' +
      hex.slice(8, 10).join('') +
      '-' +
      hex.slice(10, 16).join('')
    );
  }

  function getOrCreateVisitorId() {
    try {
      var existing = window.localStorage.getItem(VISITOR_KEY);
      if (existing && existing.length >= 8 && existing.length <= 64) return existing;
      var id = '';
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        id = window.crypto.randomUUID();
      } else {
        id = uuidFallback();
      }
      if (!id) return null;
      window.localStorage.setItem(VISITOR_KEY, id);
      return id;
    } catch (_) {
      return null;
    }
  }

  function clearPatchHighlight() {
    root.querySelectorAll('[data-wod3d-parcheado-slug]').forEach(function (card) {
      card.classList.remove('is-active');
      var badge = card.querySelector('[data-wod3d-parcheado-badge]');
      if (badge) badge.hidden = true;
    });
  }

  function applyPatchHit(slug) {
    if (!slug) return false;
    var hit = root.querySelector('[data-wod3d-parcheado-hit]');
    var labelEl = root.querySelector('[data-wod3d-parcheado-hit-label]');
    var grid = root.querySelector('[data-wod3d-parcheado-patches] .wod3d-parcheado__grid');
    var cards = root.querySelectorAll('[data-wod3d-parcheado-slug]');
    var matched = null;
    var needle = String(slug).toLowerCase();

    for (var i = 0; i < cards.length; i++) {
      var s = (cards[i].getAttribute('data-wod3d-parcheado-slug') || '').toLowerCase();
      if (s && s === needle) {
        matched = cards[i];
        break;
      }
    }
    if (!matched) return false;

    clearPatchHighlight();
    var label = matched.getAttribute('data-wod3d-parcheado-label') || '';
    var api = window.Wod3dParcheadoChainCopy;
    var hasSpecificHero =
      api &&
      typeof api.buildPatchHero === 'function' &&
      !!api.buildPatchHero(needle);

    /* Specific heroes already name the patch in the H1 — skip "Te ha tocado: …". */
    if (hit) {
      if (hasSpecificHero) {
        hit.hidden = true;
      } else if (label && labelEl) {
        labelEl.textContent = '“' + label + '”';
        hit.hidden = false;
      }
    }

    matched.classList.add('is-active');
    var badge = matched.querySelector('[data-wod3d-parcheado-badge]');
    if (badge) badge.hidden = false;

    if (grid && matched.parentNode === grid && grid.firstElementChild !== matched) {
      grid.insertBefore(matched, grid.firstElementChild);
    }

    /* Mystery card must always remain last. */
    var mystery = grid && grid.querySelector('[data-wod3d-parcheado-mystery]');
    if (grid && mystery && grid.lastElementChild !== mystery) {
      grid.appendChild(mystery);
    }

    currentPatch = needle;
    return true;
  }

  function setHeadline(el, parts) {
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);
    (parts || []).forEach(function (line) {
      var span = document.createElement('span');
      span.textContent = line;
      el.appendChild(span);
    });
  }

  function setBody(el, parts) {
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);
    var buf = [];
    function flush() {
      if (!buf.length) return;
      var p = document.createElement('p');
      p.textContent = buf.join('\n');
      el.appendChild(p);
      buf = [];
    }
    (parts || []).forEach(function (line) {
      if (line === '') flush();
      else buf.push(line);
    });
    flush();
  }

  function padPos(n) {
    var api = window.Wod3dParcheadoChainCopy;
    if (api && typeof api.padChain === 'function') return api.padChain(n);
    var num = Math.floor(Number(n));
    if (!isFinite(num) || num < 1) return '01';
    if (num < 10) return '0' + num;
    return String(num);
  }

  function normalizeEyebrowForPos(eyebrow, pos) {
    if (!eyebrow) return eyebrow;
    var t = String(eyebrow);
    if (pos == null) return t;
    t = t.replace(/\s*#0*\d+\b/gi, '').replace(/\s+/g, ' ').trim();
    if (t && t.indexOf('//') !== 0 && /^[A-ZÁÉÍÓÚÜÑ0-9 /¿?¡!]+$/i.test(t)) {
      t = '// ' + t.replace(/^\/\//, '').trim();
    }
    return t;
  }

  function renderChainRail(pos, chainCount) {
    var rail = root.querySelector('[data-wod3d-parcheado-chain-rail]');
    if (!rail) return;
    while (rail.firstChild) rail.removeChild(rail.firstChild);
    if (pos == null || !isFinite(pos) || pos < 1) {
      rail.hidden = true;
      return;
    }
    var count = Math.floor(Number(chainCount));
    if (!isFinite(count) || count < 1) count = pos;

    var nodes = [];
    if (pos <= 3) {
      for (var i = 1; i <= Math.min(4, Math.max(count, pos + 1)); i++) nodes.push(i);
      if (count > 4 || pos + 1 < count) nodes.push('more');
    } else {
      nodes.push('more');
      var start = Math.max(1, pos - 1);
      var end = Math.min(count, pos + 1);
      for (var j = start; j <= end; j++) nodes.push(j);
      if (end < count) nodes.push('fwd');
    }

    nodes.forEach(function (n, idx) {
      if (idx > 0) {
        var sep = document.createElement('span');
        sep.className = 'wod3d-parcheado__chain-rail-sep';
        sep.textContent = '—';
        rail.appendChild(sep);
      }
      var el = document.createElement('span');
      if (n === 'more' || n === 'fwd') {
        el.className = 'wod3d-parcheado__chain-rail-dot';
        el.textContent = n === 'fwd' ? '→' : '···';
      } else {
        el.className = 'wod3d-parcheado__chain-rail-node';
        if (n === pos) el.className += ' is-active';
        el.textContent = padPos(n);
      }
      rail.appendChild(el);
    });
    rail.hidden = false;
  }

  function showChainBlock(copy) {
    var block = root.querySelector('[data-wod3d-parcheado-chain]');
    if (!block || !copy) return;

    var eyebrow = block.querySelector('[data-wod3d-parcheado-chain-eyebrow]');
    var posEl = block.querySelector('[data-wod3d-parcheado-chain-pos]');
    var headline = block.querySelector('[data-wod3d-parcheado-chain-headline]');
    var body = block.querySelector('[data-wod3d-parcheado-chain-body]');
    var foot = block.querySelector('[data-wod3d-parcheado-chain-foot]');

    var pos = chainMeta.visitor_position;
    var brow = normalizeEyebrowForPos(copy.eyebrow, pos);

    if (eyebrow) {
      if (brow) {
        eyebrow.textContent = brow;
        eyebrow.hidden = false;
      } else {
        eyebrow.textContent = '';
        eyebrow.hidden = true;
      }
    }

    if (posEl) {
      if (pos != null && isFinite(pos) && pos >= 1) {
        posEl.textContent = '#' + padPos(pos);
        posEl.hidden = false;
        posEl.classList.add('is-in');
      } else {
        posEl.textContent = '';
        posEl.hidden = true;
        posEl.classList.remove('is-in');
      }
    }

    renderChainRail(pos, chainMeta.chain_count);

    setHeadline(headline, copy.headline);
    setBody(body, copy.body);
    if (foot) {
      if (copy.foot) {
        if (Array.isArray(copy.foot)) {
          setTextLines(foot, copy.foot);
        } else {
          foot.textContent = copy.foot;
        }
        foot.hidden = false;
      } else {
        foot.textContent = '';
        foot.hidden = true;
      }
    }

    block.hidden = false;
    block.setAttribute('data-chain-mode', copy.mode || '');
    if (pos != null) block.setAttribute('data-chain-pos', String(pos));
  }

  function showHeroPatchObject(slug) {
    var wrap = root.querySelector('[data-wod3d-parcheado-hero-object]');
    var img = root.querySelector('[data-wod3d-parcheado-hero-object-img]');
    if (!wrap || !img || !slug) {
      if (wrap) wrap.hidden = true;
      return;
    }
    var card = root.querySelector(
      '[data-wod3d-parcheado-slug="' + String(slug).toLowerCase().replace(/"/g, '') + '"]'
    );
    var srcImg = card && card.querySelector('.wod3d-parcheado__card-media img');
    if (!srcImg) {
      wrap.hidden = true;
      img.removeAttribute('src');
      img.alt = '';
      return;
    }
    var src =
      srcImg.currentSrc ||
      srcImg.getAttribute('src') ||
      (srcImg.srcset && String(srcImg.srcset).split(',')[0].trim().split(' ')[0]) ||
      '';
    if (!src) {
      wrap.hidden = true;
      return;
    }
    img.src = src;
    img.alt = card.getAttribute('data-wod3d-parcheado-label') || '';
    wrap.hidden = false;
  }

  function parseScanResponse(data) {
    if (!data || data.ok !== true) return null;
    if (typeof data.physicalId !== 'string' || !data.physicalId) return null;
    if (typeof data.designSlug !== 'string' || !data.designSlug) return null;
    var chainCount = Math.floor(Number(data.chainCount));
    if (!isFinite(chainCount) || chainCount < 0) return null;
    var pos =
      data.visitorPosition == null ? null : Math.floor(Number(data.visitorPosition));
    if (pos !== null && (!isFinite(pos) || pos < 1)) return null;
    var kind = 'roast';
    if (data.kind === 'positive' || data.kind === 'flirt') kind = data.kind;
    return {
      physicalId: data.physicalId,
      designSlug: String(data.designSlug).toLowerCase(),
      kind: kind,
      chainCount: chainCount,
      isNewChainMember: data.isNewChainMember === true,
      visitorPosition: pos,
    };
  }

  function setTextLines(el, parts) {
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);
    (parts || []).forEach(function (line, i) {
      if (i > 0) el.appendChild(document.createElement('br'));
      el.appendChild(document.createTextNode(line));
    });
  }

  function setOptionText(el, text) {
    if (!el) return;
    var ig = el.querySelector('.wod3d-parcheado__ig');
    var igClone = ig ? ig.cloneNode(true) : null;
    while (el.firstChild) el.removeChild(el.firstChild);
    String(text || '')
      .split('\n')
      .forEach(function (line, i) {
        if (i > 0) el.appendChild(document.createElement('br'));
        if (igClone && line.indexOf('@WOD3D') !== -1) {
          var parts = line.split('@WOD3D');
          if (parts[0]) el.appendChild(document.createTextNode(parts[0]));
          el.appendChild(igClone.cloneNode(true));
          if (parts[1]) el.appendChild(document.createTextNode(parts[1]));
        } else {
          el.appendChild(document.createTextNode(line));
        }
      });
  }

  function applyTransferCopy(transfer) {
    if (!transfer) return;
    var social = root.querySelector('[data-wod3d-parcheado-social]');
    if (!social) return;

    social.setAttribute('data-transfer-mode', transfer.mode || 'custom');
    var socialEyebrow = social.querySelector('[data-wod3d-parcheado-social-eyebrow]');
    var socialHeadline = social.querySelector('[data-wod3d-parcheado-social-headline]');
    var socialBody = social.querySelector('[data-wod3d-parcheado-social-body]');
    var opt1Text = social.querySelector('[data-wod3d-parcheado-social-opt1-text]');
    var opt2Text = social.querySelector('[data-wod3d-parcheado-social-opt2-text]');
    var opt2Ico = social.querySelector('[data-wod3d-parcheado-social-opt2-ico]');
    var opt3 = social.querySelector('[data-wod3d-parcheado-social-opt3]');
    var socialFoot = social.querySelector('[data-wod3d-parcheado-social-foot]');

    if (socialEyebrow) {
      socialEyebrow.textContent = transfer.eyebrow;
      socialEyebrow.hidden = false;
    }
    setHeadline(socialHeadline, transfer.headline);
    if (socialBody) {
      socialBody.hidden = false;
      setBody(socialBody, transfer.body);
    }
    setOptionText(opt1Text, transfer.option1Text);
    setOptionText(opt2Text, transfer.option2Text);

    var opt1 = social.querySelector('[data-wod3d-parcheado-social-opt1]');
    var opt2 = social.querySelector('[data-wod3d-parcheado-social-opt2]');
    if (opt1 && !opt1.querySelector('[data-wod3d-parcheado-decision-num]')) {
      var n1 = document.createElement('span');
      n1.className = 'wod3d-parcheado__decision-num';
      n1.setAttribute('data-wod3d-parcheado-decision-num', '');
      n1.setAttribute('aria-hidden', 'true');
      n1.textContent = '01';
      opt1.insertBefore(n1, opt1.firstChild);
    }
    if (opt2 && !opt2.querySelector('[data-wod3d-parcheado-decision-num]')) {
      var n2 = document.createElement('span');
      n2.className = 'wod3d-parcheado__decision-num';
      n2.setAttribute('data-wod3d-parcheado-decision-num', '');
      n2.setAttribute('aria-hidden', 'true');
      n2.textContent = '02';
      opt2.insertBefore(n2, opt2.firstChild);
    }
    social.classList.add('is-decision');

    // Positive/flirt: keep + pass (hide Instagram share face).
    if (opt2Ico) {
      var shareFace = opt2Ico.querySelector('.wod3d-parcheado__option-ico-face--share');
      var passFace = opt2Ico.querySelector('.wod3d-parcheado__option-ico-face--pass');
      if (shareFace) shareFace.hidden = true;
      if (passFace) passFace.hidden = false;
    }
    if (opt3) opt3.hidden = true;
    if (socialFoot) {
      socialFoot.hidden = false;
      setTextLines(socialFoot, transfer.close);
    }
  }

  function setHeroCtaLines(parts) {
    var btn = root.querySelector('[data-wod3d-parcheado-reveal-btn]');
    if (!btn || !parts || !parts.length) return;
    btn.querySelectorAll('.wod3d-btn__label').forEach(function (cta) {
      setTextLines(cta, parts);
    });
  }

  function setHeroCtaLabel(label) {
    if (!label) return;
    setHeroCtaLines(String(label).split(/\n/));
  }

  /**
   * Immediate hero personalization from ?patch= (no /scan, no position claims).
   * Returns true when a physical Batch-001 design hero was applied.
   */
  function applySpecificHero(slug) {
    var api = window.Wod3dParcheadoChainCopy;
    if (!api || typeof api.buildPatchHero !== 'function') return false;
    var hero = api.buildPatchHero(slug);
    if (!hero) return false;

    var eyebrow = root.querySelector('[data-wod3d-parcheado-hero-eyebrow]');
    var headline = root.querySelector('[data-wod3d-parcheado-hero-headline]');
    var copyEl = root.querySelector('[data-wod3d-parcheado-hero-copy]');
    var closeEl = root.querySelector('[data-wod3d-parcheado-hero-close]');
    var hit = root.querySelector('[data-wod3d-parcheado-hit]');

    if (eyebrow) {
      eyebrow.textContent = hero.eyebrow || '';
      eyebrow.hidden = !hero.eyebrow;
    }
    setHeadline(headline, hero.headline);
    setBody(copyEl, hero.body);
    if (closeEl) {
      if (hero.close && hero.close.length) {
        setTextLines(closeEl, hero.close);
        closeEl.hidden = false;
      } else {
        closeEl.textContent = '';
        closeEl.hidden = true;
      }
    }
    if (hero.cta && hero.cta.length) setHeroCtaLines(hero.cta);
    if (hit) hit.hidden = true;
    showHeroPatchObject(slug);

    root.setAttribute('data-hero-mode', 'specific');
    root.setAttribute('data-hero-slug', String(slug).toLowerCase());
    return true;
  }

  function applyPositiveNarrative(parsed) {
    var api = window.Wod3dParcheadoChainCopy;
    if (!api) return;

    root.classList.add('is-positive');
    root.classList.remove('is-flirt');
    root.setAttribute('data-patch-kind', 'positive');

    var slug = (parsed && parsed.designSlug) || currentPatch || '';
    var pos = parsed && parsed.visitorPosition != null ? parsed.visitorPosition : null;
    var isFijado = slug === (api.FIJADO_SLUG || 'te-he-visto-entrenar');

    // Fijado: narrative lives in chain block; keep brand reveal (HOLA / SOMOS).
    if (!isFijado) {
      var revealCopy =
        api.buildPositiveReveal && api.buildPositiveReveal(slug, pos);
      if (revealCopy) {
        var revealEyebrow = root.querySelector('[data-wod3d-parcheado-reveal-eyebrow]');
        var revealHeadline = root.querySelector('[data-wod3d-parcheado-reveal-headline]');
        var revealBody = root.querySelector('[data-wod3d-parcheado-reveal-copy]');
        if (revealEyebrow) {
          revealEyebrow.textContent = revealCopy.eyebrow;
          revealEyebrow.hidden = false;
        }
        setHeadline(revealHeadline, revealCopy.headline);
        setBody(revealBody, revealCopy.body);
      }
    }

    var transfer =
      api.buildPositiveTransfer && api.buildPositiveTransfer(pos, slug);
    if (transfer) {
      transfer.mode = 'positive';
      applyTransferCopy(transfer);
    }
  }

  function applyFlirtNarrative(parsed) {
    var api = window.Wod3dParcheadoChainCopy;
    if (!api) return;

    root.classList.add('is-flirt');
    root.classList.remove('is-positive');
    root.setAttribute('data-patch-kind', 'flirt');

    if (api.FLIRT_HERO_CTA) setHeroCtaLabel(api.FLIRT_HERO_CTA);

    var transfer =
      api.buildFlirtTransfer && api.buildFlirtTransfer(parsed.visitorPosition);
    if (transfer) {
      transfer.mode = 'flirt';
      applyTransferCopy(transfer);
    }
  }

  function applyFlirtFallbackNarrative() {
    var api = window.Wod3dParcheadoChainCopy;
    if (!api || !api.buildFlirtFallback) return;
    root.classList.add('is-flirt');
    root.setAttribute('data-patch-kind', 'flirt');
    if (api.FLIRT_HERO_CTA) setHeroCtaLabel(api.FLIRT_HERO_CTA);
    var copy = api.buildFlirtFallback();
    if (copy) showChainBlock(copy);
  }

  function applyPositiveFallbackNarrative() {
    var api = window.Wod3dParcheadoChainCopy;
    if (!api || !api.buildPositiveFallback) return;
    root.classList.add('is-positive');
    root.setAttribute('data-patch-kind', 'positive');
    var copy = api.buildPositiveFallback(currentPatch);
    if (copy) showChainBlock(copy);
  }

  function applyChainSuccess(parsed) {
    chainMeta.physical_id = parsed.physicalId;
    chainMeta.chain_count = parsed.chainCount;
    chainMeta.visitor_position = parsed.visitorPosition;
    chainMeta.is_new_chain_member = parsed.isNewChainMember;
    chainMeta.patch_kind = parsed.kind;

    // Physical ID wins: reconcile design from API.
    applyPatchHit(parsed.designSlug);

    root.classList.remove('is-positive', 'is-flirt');
    if (parsed.kind === 'positive') {
      applyPositiveNarrative(parsed);
    } else if (parsed.kind === 'flirt') {
      applyFlirtNarrative(parsed);
    } else {
      root.setAttribute('data-patch-kind', 'roast');
    }

    var builder =
      (window.Wod3dParcheadoChainCopy && window.Wod3dParcheadoChainCopy.buildChainCopy) || null;
    if (!builder) return;
    if (parsed.chainCount < 1) return;

    var copy = builder({
      isNewChainMember: parsed.isNewChainMember,
      visitorPosition: parsed.visitorPosition,
      chainCount: parsed.chainCount,
      kind: parsed.kind,
      designSlug: parsed.designSlug,
    });
    if (copy) showChainBlock(copy);
  }

  function fetchChainScan() {
    var apiUrl = (root.getAttribute('data-chain-api-url') || '').trim();
    if (!apiUrl || !physicalId) return;

    var visitorId = getOrCreateVisitorId();
    var payload = { physicalId: physicalId };
    if (visitorId) payload.visitorId = visitorId;

    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = null;
    if (ctrl) {
      timer = window.setTimeout(function () {
        try {
          ctrl.abort();
        } catch (_) {}
      }, SCAN_TIMEOUT_MS);
    }

    var init = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'omit',
      mode: 'cors',
    };
    if (ctrl) init.signal = ctrl.signal;

    fetch(apiUrl, init)
      .then(function (res) {
        if (!res || !res.ok) return null;
        return res.json().catch(function () {
          return null;
        });
      })
      .then(function (data) {
        var parsed = parseScanResponse(data);
        if (parsed) applyChainSuccess(parsed);
      })
      .catch(function () {
        /* progressive enhancement: silent */
      })
      .then(function () {
        if (timer) window.clearTimeout(timer);
      });
  }

  function reveal(opts) {
    var target = root.querySelector('[data-wod3d-parcheado-reveal]');
    var firstReveal = !root.classList.contains('is-revealed');

    root.classList.add('is-revealed');

    if (target && firstReveal && !reduceMotion) {
      target.classList.remove('is-entering');
      void target.offsetWidth;
      target.classList.add('is-entering');
    }

    if (opts && opts.track !== false && firstReveal) {
      track('reveal_click');
    }

    if ((opts && opts.scroll === false) || !target) return;

    var behavior = reduceMotion ? 'auto' : 'smooth';
    try {
      target.scrollIntoView({ behavior: behavior, block: 'start' });
    } catch (_) {
      target.scrollIntoView(true);
    }
  }

  function initCrowdMotion() {
    var frame = root.querySelector('[data-wod3d-parcheado-crowd-frame]');
    if (!frame) return;
    if (reduceMotion) {
      frame.classList.add('is-in');
      return;
    }
    if (typeof IntersectionObserver === 'undefined') {
      frame.classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          frame.classList.add('is-in');
          io.disconnect();
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    io.observe(frame);
  }

  function onReady() {
    // Immediate design hero from ?patch= (no API). Generic Liquid hero stays as fallback.
    var specific = applySpecificHero(currentPatch);
    // Carousel highlight / reorder for Batch-001 physical cards only.
    var hit = applyPatchHit(currentPatch);
    if (specific) {
      var hitEl = root.querySelector('[data-wod3d-parcheado-hit]');
      if (hitEl) hitEl.hidden = true;
    }
    track('landing_view');

    // Fallback: catalog kind without validated physicalId → safe copy only.
    // Never invent chain position from query params.
    // Skip when specific hero already owns the narrative (no fake #01).
    if (!physicalId && hit && !specific) {
      var card = root.querySelector('[data-wod3d-parcheado-slug].is-active');
      var kind = card && card.getAttribute('data-wod3d-parcheado-kind');
      if (kind === 'flirt') {
        applyFlirtFallbackNarrative();
      } else if (kind === 'positive') {
        applyPositiveFallbackNarrative();
      }
    } else if (!physicalId && specific) {
      // Kind styling only (CTA already from buildPatchHero).
      var card2 = root.querySelector('[data-wod3d-parcheado-slug].is-active');
      var kind2 = card2 && card2.getAttribute('data-wod3d-parcheado-kind');
      if (kind2 === 'flirt') {
        root.classList.add('is-flirt');
        root.setAttribute('data-patch-kind', 'flirt');
      } else if (kind2 === 'positive') {
        root.classList.add('is-positive');
        root.setAttribute('data-patch-kind', 'positive');
      } else if (kind2 === 'roast') {
        root.setAttribute('data-patch-kind', 'roast');
      }
    }

    // Async chain — never blocks reveal / CTAs.
    fetchChainScan();
    initCrowdMotion();

    var revealBtn = root.querySelector('[data-wod3d-parcheado-reveal-btn]');
    if (revealBtn) {
      revealBtn.addEventListener('click', function (e) {
        e.preventDefault();
        reveal({ track: true, scroll: true });
      });
    }

    root.querySelectorAll('[data-wod3d-parcheado-track]').forEach(function (el) {
      el.addEventListener('click', function () {
        var name = el.getAttribute('data-wod3d-parcheado-track');
        if (name) track(name);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();

/* live-publish 20260919T134316Z */
